import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const commonAPI = createApi({
    reducerPath: "commonAPI",
    baseQuery: fetchBaseQuery({
        baseUrl: BaseUrl,
        prepareHeaders: (headers) => {
            headers.set("Accept", "application/json");
            headers.set("Content-Type", "application/json");
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getColorTheme: builder.query({
            query: () => `color-themes`,
        }),
        getFooterContent: builder.query({
            query: () => `footer`,
        }),

        getPaymentIcons: builder.query({
          query: () => `payment-gateway-icons`,
      }),

        getPaymentMOdes: builder.query({
            query: () => `payment-modes`,
        }),
        gusetCheckoutStatusDisplay: builder.query({
            query: () => `checkout-settings`,
        }),
      encryptData: builder.mutation({
        query: (formData) => ({
          url: "decrypt",
          method: "POST",
          body: formData,
        }),
      }),

      resetPasswordMail: builder.mutation({
        query: (formData) => ({
          url: "mail-reset-password",
          method: "POST",
          body: formData,
        }),
      }),

  
    }),
});

export const { useGetColorThemeQuery, useGetFooterContentQuery, useGetPaymentMOdesQuery, useGusetCheckoutStatusDisplayQuery, useEncryptDataMutation , useResetPasswordMailMutation , useGetPaymentIconsQuery} = commonAPI;
